import moment from 'moment'

export const EVIDENCE_TYPES = {
  MENSUAL: 'MENSUAL',
  CTS: 'CTS',
  GRATIFICACION: 'GRATIFICACION'
}

// Months with TWO forms (special CTS/Grati + a follow-up MENSUAL the next day).
// All other months get a single MENSUAL on the provider's cycle_day.
export const SPECIAL_MONTHS = {
  5: [
    { day: 1, type: EVIDENCE_TYPES.CTS },
    { day: 2, type: EVIDENCE_TYPES.MENSUAL }
  ],
  7: [
    { day: 1, type: EVIDENCE_TYPES.GRATIFICACION },
    { day: 2, type: EVIDENCE_TYPES.MENSUAL }
  ],
  11: [
    { day: 2, type: EVIDENCE_TYPES.CTS },
    { day: 3, type: EVIDENCE_TYPES.MENSUAL }
  ],
  12: [
    { day: 1, type: EVIDENCE_TYPES.GRATIFICACION },
    { day: 2, type: EVIDENCE_TYPES.MENSUAL }
  ]
}

export const isSpecialMonth = (month) => !!SPECIAL_MONTHS[month]

const assertCycleDay = (cycleDay) => {
  const day = parseInt(cycleDay)
  if (!Number.isInteger(day) || day < 1 || day > 31) {
    throw new Error(`cycleDay must be an integer in [1,31], got: ${cycleDay}`)
  }
  return day
}

export const getFormsForMonth = (cycleDay, year, month) => {
  if (SPECIAL_MONTHS[month]) {
    return SPECIAL_MONTHS[month].map((f) => ({
      date: moment({ year, month: month - 1, day: f.day }).format('YYYY-MM-DD'),
      type: f.type
    }))
  }

  const day = assertCycleDay(cycleDay)
  const base = moment({ year, month: month - 1, day: 1 })
  const actualDay = Math.min(day, base.daysInMonth())

  return [
    {
      date: base.date(actualDay).format('YYYY-MM-DD'),
      type: EVIDENCE_TYPES.MENSUAL
    }
  ]
}

export const getTypeForDate = (openingDate) => {
  const m = moment(openingDate)
  const month = m.month() + 1
  const day = m.date()

  if (SPECIAL_MONTHS[month]) {
    const slot = SPECIAL_MONTHS[month].find((s) => s.day === day)
    return slot ? slot.type : EVIDENCE_TYPES.MENSUAL
  }

  return EVIDENCE_TYPES.MENSUAL
}

export const advanceNextOpening = (lastOpeningDate, cycleDay) => {
  const last = moment(lastOpeningDate)
  const probe = last.clone()

  for (let i = 0; i < 24; i += 1) {
    const forms = getFormsForMonth(cycleDay, probe.year(), probe.month() + 1)
    for (const f of forms) {
      if (moment(f.date).isAfter(last, 'day')) {
        const period = moment(f.date).subtract(1, 'month')
        return {
          date: f.date,
          type: f.type,
          periodMonth: period.month() + 1,
          periodYear: period.year()
        }
      }
    }
    probe.add(1, 'month')
  }

  throw new Error('Could not determine next opening within 2 years')
}

export const getNextOpening = (cycleDay, fromDate) => {
  const from = moment(fromDate || moment()).startOf('day')
  const probe = from.clone()

  for (let i = 0; i < 24; i += 1) {
    const forms = getFormsForMonth(cycleDay, probe.year(), probe.month() + 1)
    for (const f of forms) {
      if (moment(f.date).isSameOrAfter(from, 'day')) {
        const period = moment(f.date).subtract(1, 'month')
        return {
          date: f.date,
          type: f.type,
          periodMonth: period.month() + 1,
          periodYear: period.year()
        }
      }
    }
    probe.add(1, 'month')
  }

  throw new Error('Could not determine next opening within 2 years')
}

// Back-compat alias for callers still using the old name.
export const getTypeForOpening = getTypeForDate
